<template>
	<div class="grid lg:grid-cols-2 gap-4 no-bottom-margin" :class="hasOneOverpayment ? 'xl:grid-cols-5' : 'xl:grid-cols-4'">
		<BaseDatepicker
			ref="BaseDatepicker"
			v-model="receipt.date"
			:required="true"
			:disabled="disabled"
			:max_date="new Date()"
			@change="$emit('change', receipt)"
		/>
		<BaseInputNumber
			ref="BaseInputNumber"
			v-model="receipt.value"
			@change="$emit('change', receipt)"
			:required="true"
			:precision="2"
			:disabled="disabled"
			:placeholder="$t('sum')"
		/>
		<BaseSelect
			ref="BaseSelect.typeOptions"
			:options="typeOptions"
			@changed="changedType"
			v-model="receipt.type"
			:required="true"
			:error-message="$t('required_value')"
			:disabled="disabled"
		/>
		<BaseSelect
			ref="BaseSelect.payerOptions"
			:options="payerOptions"
			@changed="$emit('change', receipt)"
			v-model="receipt.payer"
			:required="true"
			:error-message="$t('required_value')"
			:disabled="disabled"
		/>
		<BaseSelect
			v-if="isOverpayment"
			ref="BaseSelect.payerOptions"
			:options="overpaymentOptions"
			@changed="$emit('change', receipt)"
			v-model="receipt.overpaymentType"
			:required="true"
			:error-message="$t('required_value')"
			:disabled="disabled"
		/>
	</div>
</template>
<script>
import BaseDatepicker from '@/components/forms/inputs/BaseDatepicker';
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import Validate from '@/mixins/Validate';
import { PaymentReceiptTypeEnum } from '@/api/generated/models';

export default {
	name: 'DamageCasePaymentReceiptRow',
	components: { BaseSelect, BaseInputNumber, BaseDatepicker },
	mixins: [Validate],
	props: {
		notPayed: { required: true },
		receipt: {},
		typeOptions: {},
		payerOptions: {},
		isOverpayment: { default: false, required: false },
    hasOneOverpayment: {default: false, required: false},
		overpaymentOptions: {},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		changedType() {
			if (!this.receipt.value && this.receipt.type.value === PaymentReceiptTypeEnum.Refund) {
				this.receipt.value = -1 * this.notPayed;
			}
			this.$emit('change', this.receipt);
		},
	},
};
</script>

<style lang="sass">
.no-bottom-margin .form-group
	margin-bottom: 0
</style>
